<script lang="ts">
  import { onMount } from 'svelte'
  import DropdownMenu from './DropdownMenu.svelte'
  import Barchart from './Barchart.svelte'
  import { usersAnswers } from '../api/api'
  import { QUESTIONS_DEF } from '../constants/questions_def'
  import { countBy } from 'lodash-es'

  let rawDataset = []

  onMount(async () => {
    const { data } = await usersAnswers([0, 1000000])
    rawDataset = data
  })

  $: answersStatsDataset = QUESTIONS_DEF.filter(
    ({ id }) => id !== 'start_survey' && id !== 'end_of_survey' && id !== 'MID_VIZ'
  )
    .map(({ id, question }) => ({
      question,
      answers: rawDataset.flatMap((d) => d.answers[id]).filter((d) => d !== undefined),
    }))
    .map((d) => ({
      ...d,
      answersText: d.answers.map((d) => d.text),
    }))
    .map((d) => ({
      ...d,
      answersStat: Object.entries(countBy(d.answers, 'text')).map(([label, value]) => ({
        label,
        value,
      })),
    }))
</script>

<DropdownMenu selected="Risultati del sondaggio" />

<div class="analisi-risposte-wrapper">
  {#each answersStatsDataset as { question, answersStat }}
    <div class="question">
      <div class="title">{question}</div>

      <Barchart dataset={answersStat} />
    </div>
  {/each}
</div>

<style>
  .analisi-risposte-wrapper {
    padding-top: 55px;
    padding-left: 1em;
    padding-right: 1em;
  }

  .question {
    margin: 60px 0;
  }

  .title {
    font-size: 16px;
    font-weight: 600;
  }
</style>
